import constants from '../common/constants';
import { logJSError } from './thirdParties';

export function getTemplateData(dataSelect) {
   try {
      const inlineJsonElement = document.querySelector(
         `script[type="application/json"][data-gig-selector="${dataSelect}"]`,
      );
      if (inlineJsonElement) {
         const data = JSON.parse(inlineJsonElement.textContent);
         return data;
      }
      return false;
   } catch (err) {
      logJSError(err);
      console.error(`Couldn't read JSON data from ${dataSelect}`, err);
   }
   return false;
}

/** 
 * Formats date (in local time zone, i.e. no getUTC*)
 * @param {Date} date 
 * @returns {string} 'Jan 02, 2006'
 */
export function formatDate(date) {
   const m = constants.monthsShort[date.getMonth()];
   const d = date.getDate();
   const y = date.getFullYear();
   return `${m} ${d}, ${y}`;
}

/**
 * @param {ApiImage} img
 * @param {string} key
 */
export function getThumbnail(img, key) {
   return img.data.thumbnails.find(d => d.key === key);
}

/**
 * @param {ApiImage} img
 * @param  {...string} keys
 */
export function makeSrcset(img, ...keys) {
   return keys.map(k => getThumbnail(img, k))
      .filter(d => d && d.width <= img.width)
      .map(d => `${d.url} ${d.width}w`).join(', ');
}

export function getDirectusHeaders() {
   const headers = {};

   if (process.env.DIRECTUS_PROTO) {
      headers['X-Forwarded-Proto'] = process.env.DIRECTUS_PROTO;
   }

   if (process.env.DIRECTUS_HOST) {
      headers['X-Forwarded-Host'] = process.env.DIRECTUS_HOST;
   }

   return headers;
}